/**
 * Resolve which billing error a UI surface should show when a batch can have
 * both credit and storage failures at once. Storage takes priority over
 * credits — when both are insufficient, the user typically can't proceed
 * regardless of credit balance, so we surface the storage problem first.
 *
 * Consumers (BatchCard subtext, BillingActionRow button + useTopUp routing)
 * read these flags so the priority rule lives in one place. If the rule ever
 * flips, change it here.
 */
export function resolveBillingErrorPriority(
  hasStorageFails: boolean,
  hasCreditFails: boolean,
): { showStorageErrors: boolean; showCreditErrors: boolean } {
  return {
    showStorageErrors: hasStorageFails,
    showCreditErrors: hasCreditFails && !hasStorageFails,
  };
}
